import { render, staticRenderFns } from "./PaymentHeaderTop.vue?vue&type=template&id=01dd5aba&scoped=true&"
import script from "./PaymentHeaderTop.vue?vue&type=script&lang=js&"
export * from "./PaymentHeaderTop.vue?vue&type=script&lang=js&"
import style0 from "./PaymentHeaderTop.vue?vue&type=style&index=0&id=01dd5aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dd5aba",
  null
  
)

export default component.exports